import { render, staticRenderFns } from "./appDetail.vue?vue&type=template&id=fd7834a4&scoped=true"
import script from "./appDetail.vue?vue&type=script&lang=js"
export * from "./appDetail.vue?vue&type=script&lang=js"
import style0 from "./appDetail.vue?vue&type=style&index=0&id=fd7834a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7834a4",
  null
  
)

export default component.exports